/*
 * Copyright (c) 2018 Network International.
 * The copyright notice above does not evidence any
 * actual or intended publication of such source code.
 */

import React, { Fragment, useContext } from 'react';
import { bool, shape, string } from 'prop-types';
import { isEmpty } from 'lodash';
import { Col, Container, Row } from 'ni-ui/layout';
import { Alert, Banner, NotificationType } from 'ni-ui/notification';
import styles from './styles.scss';
import { AppContext } from '../../app-context';

export const ErrorCase = ({ isCustomError, error, customErrorPage }) => (
  <Fragment>
    {isCustomError ? (
      <Error
        customErrorPage={customErrorPage}
      />
      ) : (
        <Error messageKey={error.message} disableI18n={error.disableI18n} />
      )}
  </Fragment>
);
ErrorCase.propTypes = {
  isCustomError: true,
  error: shape({}),
  customErrorPage: shape({}),
};

ErrorCase.defaultProps = {
  isCustomError: null,
  error: null,
  customErrorPage: null,
};
const Error = ({ messageKey, disableI18n, customErrorPage }) => {
  const { isDarkTheme } = useContext(AppContext);
  return (
    <div
      className={`${styles.errorContainer} ${isDarkTheme ? styles.darkBackground : ''}`}
      style={!isEmpty(customErrorPage) ? { justifyContent: 'center' } : {}}
    >
      {isEmpty(customErrorPage) ? (
        <Banner
          type={NotificationType.ERROR}
          textKey="ERROR"
        />
      ) : null}

      {isEmpty(customErrorPage) ? (
        <Fragment>
          <Container>
            <Row>
              <Col span={2} sm={0} />
              <Col span={8} sm={12}>
                <div className={`${styles.errorWhiteContainer} ${isDarkTheme ? styles.darkBackground : ''}`}>
                  <Alert
                    type={NotificationType.ERROR}
                    textKey={messageKey}
                    disableI18n={disableI18n}
                  />
                  <div className={styles.footer} />
                </div>
              </Col>
              <Col span={2} sm={0} />
            </Row>
          </Container>
        </Fragment>
      ) : (
        <Container>
          <Row>
            <Col span={2} sm={0} />
            <Col span={8} sm={12}>
              <div className={styles.errorWhiteContainer}>
                <div style={{ margin: '10px', textAlign: 'center' }}>
                  <img src={customErrorPage.logoUrl} style={{ width: '40%' }} alt="" role="img" />
                </div>
                <Alert
                  type={NotificationType.ERROR}
                  textKey="ERROR_MESSAGE_PAGE"
                  values={{ message: customErrorPage.message }}
                />
                <div className={styles.footer} />
              </div>
            </Col>
            <Col span={2} sm={0} />
          </Row>
        </Container>
      )}
    </div>
  )
};


Error.propTypes = {
  messageKey: string,
  disableI18n: bool,
  customErrorPage: shape({}),
};

Error.defaultProps = {
  messageKey: 'FAILED_TO_LOAD_ORDER_DETAILS',
  disableI18n: false,
  customErrorPage: null,
};


export default Error;
